// Shared "is this coupon expiring soon" check - same threshold Coupons.jsx
// already uses for its own "Utløper snart" badge, so Home's coupon cards can
// show the same urgency without duplicating the date math a second time.
const EXPIRING_SOON_DAYS = 7;

export function getDaysUntilExpiry(expirationDateStr) {
  if (!expirationDateStr) return null;
  const [y, m, d] = expirationDateStr.split('-');
  const expDate = new Date(y, m - 1, d, 23, 59, 59);
  return (expDate - Date.now()) / 86400000;
}

export function isExpiringSoon(expirationDateStr) {
  const daysLeft = getDaysUntilExpiry(expirationDateStr);
  return daysLeft !== null && daysLeft >= 0 && daysLeft <= EXPIRING_SOON_DAYS;
}
